<!-- Gráfica circular de eventos del organizador (Se usa en la vista src/views/admin/Home.vue)-->
<!-- El componente obtiene los datos de los eventos con una consulta directa con express y mongoose-->
<template>
  <v-row justify="center" class="fill-height">
    <v-col cols="12">
      <h2 class="headline font-weight-bold">Pagos de eventos</h2>
      <v-divider></v-divider>

      <!-- LISTA DESPLEGABLE CON TODOS LOS EVENTOS DE UNA ORGANIZACIÓN -->
      <v-row justify="center">
        <v-col cols="12" md="6" class="pb-0">
          <v-select
            v-model="selectedEvent"
            :items="eventList"
            label="Selecciona un evento"
            no-data-text="Sin eventos"
            :loading="loading"
            :value="selectedEvent"
            @change="updateGraphic()"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" class="pt-0">
          <v-row justify="center">
            <v-col cols="9" md="8" lg="7" xl="5" class="pos-relative">
              <!-- GRÁFICA DE DONA -->
              <event-doughnut-chart-config :chart-data="paymentTypesDataset" class="canvas"></event-doughnut-chart-config>

              <!-- ACUMULADO DE VENTAS -->
              <div class="center-in-chart">
                <span
                  class="headline font-weight-bold"
                  v-if="total>0"
                  style="z-index:1;"
                >${{ total | currency }}</span>
                <span class="headline font-weight-bold" v-else>$0.00</span>
              </div>
            </v-col>

            <!-- ETIQUETAS DE MÉTODOS DE PAGO -->
            <v-col cols="12" class="text-center">
              <span v-for="(method, index) in paymentMethods" :key="index">
                <v-chip class="mx-3 mx-lg-5" :color="colors[index]" small>{{ method }}</v-chip>
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import eventDoughnutChartConfig from "./eventDoughnutChartConfig";
import { mapState, mapMutations, mapActions } from "vuex";
import { ChartConfig } from "@/constants/chart-config";
export default {
  components: {
    eventDoughnutChartConfig
  },
  data() {
    return {
      paymentTypesDataset: {
        labels: ["Spei", "Tarjeta", "Efectivo"],
        datasets: [
          {
            data: [1, 1, 1],
            backgroundColor: [
              ChartConfig.color.secondary,
              ChartConfig.color.success,
              ChartConfig.color.accent,
              ChartConfig.color.info,
              ChartConfig.color.danger
            ],
            borderWidth: [0, 0, 0],
            hoverBackgroundColor: [
              ChartConfig.color.secondary,
              ChartConfig.color.success,
              ChartConfig.color.accent,
              ChartConfig.color.info,
              ChartConfig.color.danger
            ]
          }
        ]
      },
      total: 0,
      selectedEvent: "",
      loading: false,
      paymentMethods: ["Spei", "Tarjeta", "Efectivo"],
      colors: ["secondary", "success", "accent", "info", "danger"],
      eventsWithCost: [],
      eventList: []
    };
  },
  computed: {
    ...mapState("event", ["events", "organizationEventList"]),
    ...mapState("order", ["ordersEventDoughnutChart"]),
  },
  methods: {
    ...mapActions("event", ["fetchUserEvents", "fetchOrganizerEventListApi"]),
    ...mapActions("order", ["fetchSalesPerEventApi"]),
    ...mapMutations("user", ["logout"]),
    ...mapMutations("notifications", ["show"]),
    /**
     * Función para actualizar la gráfica con un evento seleccionado.
     */
    async updateGraphic() {
      this.loading = true;
      let paymentTypesData = {};
      let profits = 0;
      let globalProfits = 0;
      let globalPaymentTypes = { Spei:0, Tarjeta:0, Efectivo:0 }
      await this.fetchSalesPerEventApi(this.selectedEvent);
      profits = this.ordersEventDoughnutChart.reduce((total, order) => {
        // INCREMENTO POR TIPO DE PAGO
        if (
          paymentTypesData.hasOwnProperty(
            order.paymentInformation.paymentType
          )
        )
          paymentTypesData[order.paymentInformation.paymentType]++;
        else paymentTypesData[order.paymentInformation.paymentType] = 1;

        // INCREMENTO DE GANANCIAS
        return total + order.total;
      }, 0);
      this.total = profits;
      // CAMBIO DE NOMBRES DE TIPOS DE PAGO
      let formattedPaymentTypes = JSON.parse(
        JSON.stringify({
          Spei: paymentTypesData["BANK_TRANSFER"] || 0,
          Tarjeta: paymentTypesData["CARD"] || 0,
          Efectivo: paymentTypesData["CASH"] || 0
        })
      );

      // SI NO HAY GANANCIAS  MUESTRA UNA GRÁFICA POR DEFECTO
      if(profits==0){
        this.paymentTypesDataset.labels=['Spei (SIN VENTAS)','Tarjeta (SIN VENTAS)','Efectivo (SIN VENTAS)'];
        //Poner todos los parámetros en "1" para que la gráfica se divida en partes iguales.
        formattedPaymentTypes.Spei = 1;
        formattedPaymentTypes.Tarjeta = 1;
        formattedPaymentTypes.Efectivo = 1;
        let temp = { ...this.paymentTypesDataset };
        temp.datasets[0].data = Object.values(
          formattedPaymentTypes
        );
        this.paymentTypesDataset = temp;
      }else{ 
        this.paymentTypesDataset.labels=['Spei','Tarjeta','Efectivo']
        let temp = { ...this.paymentTypesDataset };
        temp.datasets[0].data = Object.values(
          formattedPaymentTypes
        );
        this.paymentTypesDataset = temp;
      }
      profits=0;
      formattedPaymentTypes = {};
      paymentTypesData = {};
      this.loading = false;
    },
    /**
     * Función que obtiene la lista de eventos de organizador y solo muestra los eventos con costo.
     * Función que valida si la sesión del usuario es válida
     */
    async formatEventList() {
      // Obtener la lista de eventos del organizador
      let res = await this.fetchOrganizerEventListApi();
      // Validar token de usuario
      if (res.message == 'Autenticacion requerida ' || res.message == 'jwt expired' || res.message == 'invalid signature') {
        this.logout();
        this.show({ text: "La sesión ha expirado 😔", color: "yellow darken-3" });
        this.$router.push("/login");
      }
      this.eventsWithCost = this.organizationEventList.filter(event => event.freeEvent == false);
      this.eventsWithCost.forEach( event => {
        this.eventList.push({text: event.name, value: event._id});
      });
      if (this.eventList.length > 0){
        this.selectedEvent = this.eventList[0].value;
        await this.updateGraphic();
      }
    },
  },
  async mounted() {
    await this.formatEventList();
  }
};
</script>
<style scoped>
.center-in-chart {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.pos-relative {
  position: relative;
}
.canvas >>> .chartjs-render-monitor {
  z-index: 2;
  position: relative;
}
</style>